import React from 'react'
import { ConnectedRouter } from 'connected-react-router'
import { history } from 'js/redux/middleware/history'
import Routes from './routes'
import 'style/tailwind.css'
import 'style/mobile.css'
import DarkMode from './view/component/dark-mode'

const App = () => {
  return (
        <div className='App'>
          <DarkMode >
            <ConnectedRouter history={history}>
                <Routes />
            </ConnectedRouter>
          </DarkMode>
        </div>
  )
}

export default App
